import { render } from "./MessageStrip.vue?vue&type=template&id=16d7a42f"
import script from "./MessageStrip.vue?vue&type=script&lang=js"
export * from "./MessageStrip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__